/**
 * This function returns a random boolean value.
 * The weight determines the likelihood of returning true. The higher the weight, the more likely it is to return true.
 * @returns
 */
export function randomBoolean(weight = 0.5): boolean {
	return Math.random() >= 1 - weight;
}
